export type I_Date = string | number | Date | I_dateObject | number[];
export type I_dateObject = { year?: number, month?: number, day?: number, hour?: number, minute?: number, second?: number, milisecond?: number }
export type I_dateUnit = 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second' | 'milisecond'
export default class AIODate {
    isThisWeek = (date: I_Date, jalali?: boolean): boolean => {
        jalali = jalali === undefined ? this.isJalali(date) : jalali
        const [year, month, day] = this.toArray(date, jalali)
        const days = this.getDaysOfWeek([year, month, day])
        for (let d of days) {
            if (year !== d[0]) { continue }
            if (month !== d[1]) { continue }
            if (day !== d[1]) { continue }
            return true
        }
        return false
    }
    isThisMonth = (date: I_Date, jalali?: boolean): boolean => {
        jalali = jalali === undefined ? this.isJalali(date) : jalali
        const dateArray = this.toArray(date, jalali)
        const [year, month] = this.getToday(jalali)
        if (dateArray[0] !== year) { return false }
        if (dateArray[1] !== month) { return false }
        return true
    }
    toMiliseconds = (p: { year?: number, month?: number, day?: number, hour?: number, minute?: number, second?: number }): number => {
        const { day = 0, hour = 0, minute = 0, second = 0 } = p;
        let res = 0;
        res += day * 24 * 60 * 60 * 1000;
        res += hour * 60 * 60 * 1000;
        res += minute * 60 * 1000;
        res += second * 1000;
        return res
    }
    toIsoDate = (date: I_Date): string => {
        const [year, month, day, hour, minute, second] = this.toArray(date);
        const res = new Date(year, month - 1, day, hour, minute, second);
        return res.toISOString();
    }
    toArray = (date: I_Date, jalali?: boolean): number[] => {
        let today = this.getToday(jalali);
        if (!date || date === null) { return [today[0], 1, 1, 0, 0, 0, 0] }
        let list;
        if (Array.isArray(date)) {
            let [year, month, day, hour, minute, second, milisecond] = date;
            year = year || today[0]
            month = month || 1
            day = day || 1
            hour = hour || 0
            minute = minute || 0
            second = second || 0
            milisecond = milisecond || 0
            list = [year, month, day, hour, minute, second, milisecond]
        }
        else if (typeof date === 'string') {
            if (date.indexOf("T") !== -1) {
                //"2015-03-25T12:00:00Z"
                let [d1, t1] = date.split("T");
                let t2 = t1.split(".")[0];
                let t3 = t2.split(':');
                let d2 = d1.split('-');
                list = [...d2.map((o) => +o), ...t3.map((o) => +o), 0]
            }
            else {
                const [year = today[0], month = 1, day = 1, hour = 0, minute = 0, second = 0, milisecond = 0] = date.split(this.getSplitter(date)).map((o) => +o);
                list = [year, month, day, hour, minute, second, milisecond]
            }
        }
        else if (typeof date === 'number') {
            let d = new Date(date);
            let year = d.getFullYear();
            let month = d.getMonth() + 1;
            let day = d.getDate();
            let hour = d.getHours();
            let minute = d.getMinutes();
            let second = d.getSeconds();
            let milisecond = d.getMilliseconds();
            list = [year, month, day, hour, minute, second, milisecond]
        }
        else if (typeof date === 'object') {
            if (typeof (date as Date).getMonth === 'function') {
                let dateObject = date as Date;
                let year = dateObject.getFullYear();
                let month = dateObject.getMonth() + 1;
                let day = dateObject.getDate();
                let hour = dateObject.getHours();
                let minute = dateObject.getMinutes();
                let second = dateObject.getSeconds();
                let milisecond = dateObject.getMilliseconds();
                list = [year, month, day, hour, minute, second, milisecond]
            }
            else {
                const { year, month, day, hour, minute, second, milisecond } = date as any
                return [year || today[0], month || 1, day || 1, hour || 0, minute || 0, second || 0, milisecond || 0]
            }
        }
        else { return [] }
        if (jalali) {
            let [year, month, day] = this.toJalali([list[0], list[1], list[2]]);
            list[0] = year; list[1] = month; list[2] = day;
        }
        return list
    }
    toObject = (date: I_Date, jalali?: boolean): Required<I_dateObject> => {
        const [year, month, day, hour, minute, second, milisecond] = this.toArray(date, jalali);
        return { year, month, day, hour, minute, second, milisecond }
    }
    resetByUnit = (date: I_Date, unit: I_dateUnit, jalali?: boolean): number[] => {
        let dateArray = [...this.toArray(date, jalali)];
        const units: I_dateUnit[] = ['year', 'month', 'day', 'hour', 'minute', 'second', 'milisecond']
        const defs: number[] = [1, 1, 1, 0, 0, 0, 0]
        const index = units.indexOf(unit)
        for (let i = 0; i < units.length; i++) {
            if (index < i) { dateArray[i] = defs[i] }
        }
        return dateArray
    }
    compaire = (date1: I_Date, date2: I_Date, unit: I_dateUnit, jalali?: boolean): 'less' | 'greater' | 'equal' => {
        date1 = this.resetByUnit(date1, unit, jalali);
        date2 = this.resetByUnit(date2, unit, jalali);
        let compaireKey: 'equal' | 'less' | 'greater' = 'equal';
        for (let i = 0; i < date1.length; i++) {
            if (isNaN(date2[i])) { date2[i] = date1[i] }
            let a = date1[i];
            let b = date2[i] || 0;
            if (a < b) { compaireKey = 'less'; break; }
            if (a > b) { compaireKey = 'greater'; break; }
        }
        return compaireKey;
    }
    isLess = (date1: I_Date, date2: I_Date, unit: I_dateUnit): boolean => this.compaire(date1, date2, unit) === 'less'
    isEqual = (date1: I_Date, date2: I_Date, unit: I_dateUnit): boolean => this.compaire(date1, date2, unit) === 'equal'
    isGreater = (date1: I_Date, date2: I_Date, unit: I_dateUnit): boolean => this.compaire(date1, date2, unit) === 'greater'
    isBetween = (date1: I_Date, dates: [I_Date, I_Date], unit: I_dateUnit): boolean => this.compaire(date1, dates[0], unit) === 'greater' && this.compaire(date1, dates[1], unit) === 'less'
    isToday = (date: I_Date): boolean => this.isEqual(date, this.getToday(this.isJalali(date)), 'day')
    isNow = (date: I_Date, unit: I_dateUnit): boolean => this.isEqual(date, this.getToday(this.isJalali(date)), unit)
    getDateByDeltaMiliseconds = (date: I_Date, miliseconds: number): number[] => this.toArray(this.getTime(date) + miliseconds)
    getWeekDay = (date: I_Date, jalali?: boolean): { weekDay: string, index: number } => {
        let dateArray = this.toArray(date);
        let isJalali = typeof jalali === 'boolean' ? jalali : this.isJalali(dateArray);
        dateArray = this.toGregorian(date) as number[]
        let index = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]).getDay();
        if (isJalali) {
            index += 1;
            index = index % 7;
        }
        return { weekDay: this.getWeekDays(isJalali)[index], index };
    }
    isJalali = (date: I_Date): boolean => { return this.toArray(date)[0] < 1700 ? true : false }
    getDetails = (v: any, jalali?: boolean) => {
        const dateArray = this.toArray(v, jalali)
        const dateNumber = this.getTime(v);
        const isoDate = this.toIsoDate(v);
        const dateObject = this.toObject(v, jalali);
        const monthString = this.getMonths(jalali)[dateArray[1] - 1];
        const { weekDay, index: weekDayIndex } = this.getWeekDay(v, jalali)
        const dayIndexOfYear = this.getDayIndex(v, 'year', jalali)
        const yearStr = dateArray[0].toString();
        const monthStr = this.get2Digit(dateArray[1]);
        const dayStr = this.get2Digit(dateArray[2]);
        const hourStr = this.get2Digit(dateArray[3]);
        const minuteStr = this.get2Digit(dateArray[4]);
        const secondStr = this.get2Digit(dateArray[5]);
        return { jalali, dateNumber, isoDate, dateArray, dateObject, weekDay, weekDayIndex, monthString, dayIndexOfYear, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr }
    }
    getWeekDays = (jalali?: boolean): string[] => {
        return [
            ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
            ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
        ][jalali ? 0 : 1]
    }
    toGregorian = (date: I_Date): number[] => {
        if (!date) { return [] }
        let arr = this.toArray(date);
        let jalali = this.isJalali(arr);
        if (!jalali) { return arr }
        let [jy, jm, jd] = arr;
        var sal_a, gy, gm, gd, days;
        jy += 1595; days = -355668 + (365 * jy) + (~~(jy / 33) * 8) + ~~(((jy % 33) + 3) / 4) + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
        gy = 400 * ~~(days / 146097); days %= 146097;
        if (days > 36524) { gy += 100 * ~~(--days / 36524); days %= 36524; if (days >= 365) days++; }
        gy += 4 * ~~(days / 1461); days %= 1461;
        if (days > 365) { gy += ~~((days - 1) / 365); days = (days - 1) % 365; }
        gd = days + 1;
        sal_a = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
        arr[0] = gy; arr[1] = gm; arr[2] = gd;
        return arr;
    }
    get2Digit = (n: number): string => {
        let ns: string;
        try { ns = n.toString() }
        catch { return n.toString() }
        if (ns.length === 1) { ns = '0' + n }
        return ns
    }
    getMonths = (jalali?: boolean): string[] => {
        return [
            ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند',],
            ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER']
        ][jalali ? 0 : 1]
    }
    toJalali = (date: I_Date): number[] => {
        let arr = this.toArray(date);
        let jalali = this.isJalali(arr);
        if (jalali) { return arr }
        let [gy, gm, gd] = arr;
        var g_d_m, jy, jm, jd, gy2, days;
        g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        gy2 = (gm > 2) ? (gy + 1) : gy;
        days = 355666 + (365 * gy) + ~~((gy2 + 3) / 4) - ~~((gy2 + 99) / 100) + ~~((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
        jy = -1595 + (33 * ~~(days / 12053)); days %= 12053; jy += 4 * ~~(days / 1461); days %= 1461;
        if (days > 365) { jy += ~~((days - 1) / 365); days = (days - 1) % 365; }
        if (days < 186) { jm = 1 + ~~(days / 31); jd = 1 + (days % 31); } else { jm = 7 + ~~((days - 186) / 30); jd = 1 + ((days - 186) % 30); }
        arr[0] = jy; arr[1] = jm; arr[2] = jd;
        return arr;
    }
    getSplitter = (value: string): string => {
        let splitter = '/';
        for (let i = 0; i < value.length; i++) { if (isNaN(parseInt(value[i]))) { return value[i] } }
        return splitter;
    }
    getTime = (date: I_Date, jalali?: boolean): number => {
        if (!date) { return 0 }
        jalali = jalali === undefined ? this.isJalali(date) : jalali;
        if (typeof date === 'number') { return date }
        date = this.toArray(date);
        let [year, month = 1, day = 1, hour = 0, minute = 0, second = 0, milisecond = 0] = date;
        if (jalali) { date = this.toGregorian([year, month, day, hour, minute, second, milisecond]) }
        let time = new Date(date[0], date[1] - 1, date[2]).getTime()
        time += hour * 60 * 60 * 1000;
        time += minute * 60 * 1000;
        time += second * 1000;
        time += milisecond;
        return time;
    }
    getNextTime = (date: I_Date, offset: number, jalali?: boolean): number[] => {
        if (!offset) { return this.toArray(date) }
        jalali = jalali === undefined ? this.isJalali(date) : jalali
        let time: number = this.getTime(date, jalali);
        time += offset;
        let dateArray: number[] = this.toArray(time);
        if (jalali) {
            let [jy, jm, jd] = this.toJalali(dateArray);
            dateArray[0] = jy; dateArray[1] = jm; dateArray[2] = jd;
        }
        return dateArray;
    }
    getMonthDaysLength = (date: I_Date): number => {
        if (!date) { return 0 }
        let [year, month] = this.toArray(date);
        let jalali = this.isJalali([year, month]);
        if (jalali) { return [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, [1, 5, 9, 13, 17, 22, 26, 30].indexOf(year % 33) === -1 ? 29 : 30][month - 1] }
        else { return new Date(year, month - 1, 0).getDate(); }
    }
    getYearDaysLength = (date: I_Date): number => {
        if (!date) { return 0 }
        let [year] = this.toArray(date);
        let res = 0;
        for (let i = 1; i <= 12; i++) { res += this.getMonthDaysLength([year, i]) }
        return res
    }
    getYesterday = (date: I_Date, time?: { hour: number, minute: number, second: number }): number[] => {
        const [year, month, day] = this.toArray(date);
        let newYear = year, newMonth = month, newDay = day;
        if (day === 1) {
            if (month === 1) { newYear = newYear - 1; newMonth = 12; newDay = this.getMonthDaysLength([newYear, newMonth]) }
            else { newMonth = newMonth - 1; newDay = this.getMonthDaysLength([newYear, newMonth]) }
        }
        else { newDay = newDay - 1 }
        const { hour = 0, minute = 0, second = 0 } = time || {}
        return [newYear, newMonth, newDay, hour, minute, second]
    }
    getTomorrow = (date: I_Date, time?: { hour: number, minute: number, second: number }): number[] => {
        const [year, month, day] = this.toArray(date);
        let newYear = year, newMonth = month, newDay = day;
        const daysLength = this.getMonthDaysLength(date)
        if (day === daysLength) {
            if (month === 12) { newYear = newYear + 1; newMonth = 1; newDay = 1 }
            else { newMonth = newMonth + 1; newDay = 1 }
        }
        else { newDay = newDay + 1 }
        const { hour = 0, minute = 0, second = 0 } = time || {}
        return [newYear, newMonth, newDay, hour, minute, second]
    }
    getDays = (p: { date: I_Date, count: number, step?: number, getResult?: (v: number[]) => false | string | number | number[][] | { [key: string]: number } }) => {
        let temp: number[] = this.toArray(p.date)
        const { step = 1 } = p;
        if (!p.count) { return [] }
        const countAbs = Math.abs(p.count)
        const fn = p.count < 0 ? 'getYesterday' : 'getTomorrow'
        const result: any[] = []
        for (let i = 0; i < countAbs; i++) {
            if (i % step !== 0) { continue }
            const newDate = this[fn](temp)
            const res = p.getResult ? p.getResult(newDate) : newDate
            if (res === false) { continue }
            result.push(res)
        }
        return result
    }
    getDaysOfWeek = (date: I_Date, jalali?: boolean, pattern?: string): any[] => {
        if (!date) { return [] }
        let dateArray = this.toArray(date, jalali);
        let { index } = this.getWeekDay(dateArray);
        let firstDay: I_Date = [...dateArray];
        for (let i = 0; i < index; i++) { firstDay = this.getYesterday(firstDay); }
        const res: I_Date[] = [];
        for (let i = 0; i < 7; i++) {
            res.push(firstDay)
            firstDay = this.getTomorrow(firstDay)
        }
        if (pattern) { return res.map((o) => this.getDateByPattern(o, pattern)) }
        return res
    }
    getDatesBetween = (day1: I_Date, day2: I_Date, dayStep: number, getDate: (milisecondDate: number) => any): any[] => {
        if (!day1 || !day2) { return [] }
        day1 = this.toArray(day1).slice(0, 3).concat(0, 0, 0, 0);
        day2 = this.toArray(day2).slice(0, 3).concat(0, 0, 0, 0);
        const m1 = this.getTime(day1);
        const m2 = this.getTime(day2);
        let start = 0, end = 0;
        if (m1 <= m2) { start = m1; end = m2; }
        else { start = m2; end = m1; }
        start += dayStep * 24 * 60 * 60 * 1000;
        let res = [];
        while (start < end) {
            res.push(getDate(start));
            start += dayStep * 24 * 60 * 60 * 1000;
        }
        return res
    }
    getDeltaUnits = (date1: I_Date, date2: I_Date): { day: number, hour: number, minute: number, second: number, milisecond: number } => {
        const milisecond = this.getTime(date1) - this.getTime(date2);
        return this.milisecondsToUnits({ milisecond })
    }
    milisecondsToUnits = (p: { milisecond: number, unit?: 'hour' | 'minute' | 'second', pattern?: string }): { day: number, hour: number, minute: number, second: number, milisecond: number, pattern: string } => {
        let { milisecond, unit } = p;
        milisecond = Math.floor(Math.abs(milisecond))
        let dif = milisecond;
        let day = Math.floor(dif / (24 * 60 * 60 * 1000));
        dif -= day * (24 * 60 * 60 * 1000);
        let hour = Math.floor(dif / (60 * 60 * 1000));
        dif -= hour * (60 * 60 * 1000);
        let minute = Math.floor(dif / (60 * 1000));
        dif -= minute * (60 * 1000);
        let second = Math.floor(dif / (1000));
        dif -= second * (1000);
        milisecond = dif;
        if (unit === 'hour') {
            hour += day * 24;
            day = 0;
        }
        else if (unit === 'minute') {
            minute += day * 24 * 60;
            minute += hour * 60;
            day = 0; hour = 0;
        }
        else if (unit === 'second') {
            second += day * 24 * 60 * 60;
            second += hour * 60 * 60;
            day = 0; hour = 0; minute = 0;
        }
        const obj = {
            day: () => this.get2Digit(day),
            hour: () => this.get2Digit(hour),
            minute: () => this.get2Digit(minute),
            second: () => this.get2Digit(second),
            milisecond: () => this.get2Digit(milisecond),
        }
        const pattern = p.pattern ? this.getStringByPattern(obj, p.pattern) : ''
        return { day, hour, minute, second, milisecond, pattern }
    }
    getDaysOfMonth = (date: I_Date, pattern?: string): any[] => {
        if (!date) { return [] }
        let dateArray = this.toArray(date);
        let daysLength = this.getMonthDaysLength(date)
        let firstDay: I_Date = [dateArray[0], dateArray[1], 1];
        let res: I_Date[] = []
        for (let i = 0; i < daysLength; i++) {
            res.push(firstDay)
            firstDay = this.getTomorrow(firstDay);
        }
        if (pattern) { return res.map((o) => this.getDateByPattern(o, pattern)) }
        return res
    }
    getLastDayOfMonth = (date: I_Date): any[] => {
        let dateArray: number[] = this.toArray(date);
        let length = this.getMonthDaysLength(dateArray);
        return [dateArray[0], dateArray[1], length];
    }
    getDateByPattern = (date: I_Date, pattern: string, jalali?: boolean): string => {
        if (!date || date === null) { return '' }
        const { year, month, day, hour, minute, second, milisecond } = this.toObject(date, jalali);
        if (year && month && day && jalali === undefined) { jalali = this.isJalali([year, month, day]) }
        const obj = {
            year: () => this.get2Digit(year),
            month: () => this.get2Digit(month),
            day: () => this.get2Digit(day),
            hour: () => this.get2Digit(hour),
            minute: () => this.get2Digit(minute),
            second: () => this.get2Digit(second),
            milisecond: () => milisecond.toString(),
            monthString: () => this.getMonths(jalali)[(month || 1) - 1],
            weekDay: () => this.getWeekDays(jalali)[this.getWeekDay([year, month, day]).index]
        }
        return this.getStringByPattern(obj, pattern)
    }
    getStringByPattern = (obj: any, pattern: string) => {
        for (let prop in obj) {
            const key = `{${prop}}`
            if (pattern.indexOf(key) !== -1) {
                pattern = pattern.replace(`{${prop}}`, obj[prop]());
            }
        }
        return pattern
    }
    getTimeText(date: I_Date): string {
        const dateObject = this.toObject(date);
        let text = [], dateArray = [];
        if (dateObject.year !== undefined) { dateArray.push(this.get2Digit(dateObject.year)) }
        if (dateObject.month !== undefined) { dateArray.push(this.get2Digit(dateObject.month)) }
        if (dateObject.day !== undefined) { dateArray.push(this.get2Digit(dateObject.day)) }
        if (dateArray.length) { text.push(dateArray.join('/')) }
        let timeArray = []
        if (dateObject.hour !== undefined) { timeArray.push(this.get2Digit(dateObject.hour)) }
        if (dateObject.minute !== undefined) { timeArray.push(this.get2Digit(dateObject.minute)) }
        if (dateObject.second !== undefined) { timeArray.push(this.get2Digit(dateObject.second)) }
        if (timeArray.length) { text.push(timeArray.join(':')) }
        return text.join(' ');
    }
    getToday = (jalali?: boolean, time?: { hour: number, minute: number, second: number }): number[] => {
        let date = new Date();
        let dateArray: number[] = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), Math.round(date.getMilliseconds())]
        if (jalali) { dateArray = this.toJalali(dateArray) as number[] }
        const { hour = dateArray[3], minute = dateArray[4], second = dateArray[5] } = time || {}
        if (time?.hour !== undefined) { dateArray[3] = hour }
        if (time?.minute !== undefined) { dateArray[4] = minute }
        if (time?.second !== undefined) { dateArray[5] = second }
        return dateArray;
    }
    getTodayNumber = (jalali?: boolean, time?: { hour: number, minute: number, second: number }) => {
        const today = this.getToday(jalali, time);
        return this.getTime(today)
    }
    getDayIndex = (date: I_Date, unit: 'week' | 'year' | 'month', jalali?: boolean): number => {
        date = this.toArray(date, jalali);
        if (unit === 'week') {
            let days = this.getDaysOfWeek(date);
            for (let i = 0; i < days.length; i++) {
                let [year, month, day] = days[i];
                if (year !== date[0]) { continue }
                if (month !== date[1]) { continue }
                if (day !== date[2]) { continue }
                return i;
            }
        }
        if (unit === 'month') { return date[2] - 1; }
        if (unit === 'year') {
            let res = 0;
            for (let i = 0; i < date[1] - 1; i++) { res += this.getMonthDaysLength(date) }
            res += date[1];
            return res - 1
        }
        return 0
    }
    getCurrentRange = (unit: 'year' | 'month' | 'week' | 'day', jalali?: boolean) => {
        const t = this.getToday(jalali);
        let fromArray, toArray;
        if (unit === 'year') {
            const lastMonthDaysLength = this.getMonthDaysLength([t[0], 12])
            fromArray = [t[0], 1, 1, 0, 0]
            toArray = [t[0], 12, lastMonthDaysLength, 23, 59]
        }
        else if (unit === 'month') {
            const monthDaysLength = this.getMonthDaysLength([t[0], t[1]])
            fromArray = [t[0], t[1], 1, 0, 0]
            toArray = [t[0], t[1], monthDaysLength, 23, 59]
        }
        else if (unit === 'week') {
            const days = this.getDaysOfWeek(t, jalali)
            fromArray = [...this.toArray(days[0], jalali).slice(0, 3), 0, 0]
            toArray = [...this.toArray(days[6], jalali).slice(0, 3), 23, 59]
        }
        else {
            fromArray = [t[0], t[1], t[2], 0, 0]
            toArray = [t[0], t[1], t[2], 23, 59]
        }
        return [fromArray, toArray]
    }
    getFromToByMonth = (date: I_Date, jalali?: boolean):[number[],number[]] => {
        const dateArray = this.toArray(date, jalali)
        let fromArray, toArray;
        const monthDaysLength = this.getMonthDaysLength(date)
        fromArray = [dateArray[0], dateArray[1], 1, 0, 0]
        toArray = [dateArray[0], dateArray[1], monthDaysLength, 23, 59]
        return [fromArray, toArray]
    }
    getMonthesByFromTo = (fromDate:any,toDate:any,jalali?:boolean):[number, number][] => {
        const pushNext = (date: any, endYear: number, endMonth: number, res: [number, number][]) => {
            const d: any = this.getNext({ date, unit: 'month', step: 1, dateType: "dateArray", jalali })
            if (d[0] !== endYear && d[1] !== endMonth) {
                res.push([d[0], d[1]]);
                return pushNext(d, endYear, endMonth, res)
            }
            else { return res }
        }
        const [startYear, startMonth] = this.toArray(toDate, jalali)
        const [endYear, endMonth] = this.toArray(toDate, jalali)
        const monthes: [number, number][] = [[startYear, startMonth]]
        pushNext(fromDate, endYear, endMonth, monthes)
        if (startYear !== endYear && startMonth !== endMonth) { monthes.push([endYear, endMonth]) }
        return monthes
    }
    getDateByDateType = (date: I_Date, dateType: 'dateArray' | 'dateNumber' | 'dateObject' | 'isoDate', jalali?: boolean) => {
        if (dateType === 'dateArray') { return this.toArray(date, jalali) }
        if (dateType === 'dateNumber') { return this.getTime(date, jalali) }
        if (dateType === 'dateObject') { return this.toObject(date, jalali) }
        if (dateType === 'isoDate') { return this.toIsoDate(date) }
        return date
    }
    getNext = (p: { date: I_Date, unit: 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year', step: number, jalali?: boolean, pattern?: string, dateType?: 'dateArray' | 'dateNumber' | 'dateObject' | 'isoDate' }) => {
        const { date, unit, step, jalali, pattern, dateType = 'dateArray' } = p;
        const [year, month, day, hour, minute] = this.toArray(date, jalali);
        const time = this.getTime(date, jalali);
        const getDate = (newDate: any) => {
            if (pattern) { return this.getDateByPattern(newDate, pattern, jalali) }
            else { return this.getDateByDateType(newDate, dateType, jalali) }
        }
        const fixDayByMonth = (dateArray: number[]) => {
            const monthDaysLength = this.getMonthDaysLength(dateArray)
            if (dateArray[2] > monthDaysLength) { dateArray[2] = monthDaysLength }
            return dateArray
        }
        if (unit === 'year') { return getDate(fixDayByMonth([year + step, month, day, hour, minute])) }
        else if (unit === 'month') {
            const sign = Math.sign(step)
            const delta = Math.abs(step);
            const yearPlus = Math.floor(delta / 12)
            const monthPlus = delta - (yearPlus * 12)
            const newDate = [year + (yearPlus * sign), month + (monthPlus * sign), day, hour, minute]
            if (newDate[1] > 12) { newDate[0] += 1; newDate[1] = newDate[1] - 12 }
            else if (newDate[1] < 1) { newDate[0] -= 1; newDate[1] = 12 + newDate[1] }
            return getDate(fixDayByMonth(newDate))
        }
        else {
            let a = 0;
            if (unit === 'day') { a = step * 24 * 60 * 60 * 1000 }
            else if (unit === 'hour') { a = step * 60 * 60 * 1000 }
            else if (unit === 'minute') { a = step * 60 * 1000 }
            else if (unit === 'second') { a = step * 1000 }
            const newTime = time + a
            const newDate = this.toArray(newTime, jalali)
            return getDate(newDate)
        }
    }
    getRepeat = (p: { date: I_Date, count: number, unit: 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year', step: number, jalali?: boolean, pattern?: string, dateType?: 'dateArray' | 'dateNumber' | 'dateObject' | 'isoDate' }) => {
        const { count, step } = p, res = []
        for (let i = 0; i < count; i++) { res.push(this.getNext({ ...p, step: i * step })) }
        return res
    }
    getRangeType = (p: { startDate: I_Date, endDate: I_Date, date: I_Date }) => {
        const dateNumber = this.getTime(p.date)
        const startDate = this.getTime(p.startDate)
        const endDate = this.getTime(p.endDate)
        if (dateNumber < startDate) { return { type: 1, miliseconds: startDate - dateNumber } }
        if (dateNumber > endDate) { return { type: 1, miliseconds: dateNumber - endDate } }
        return { type: 0, miliseconds: endDate - dateNumber }
    }
    getEndOfBeforeMonth = (date?: I_Date) => {
        const [thisYear, thisMonth] = date ? this.toArray(date) : this.getToday(true)
        const year = thisMonth === 1 ? thisYear - 1 : thisYear
        const month = thisMonth === 1 ? 12 : thisMonth - 1
        const monthDaysLength = this.getMonthDaysLength([year, month])
        return this.getTime([year, month, monthDaysLength, 23, 59], true)
    }
    filterDataByDate = <T,>(p: { data: T[], getDate: (row: T) => any, fromDate?: any, toDate?: any,unit:I_dateUnit }):T[] => {
        return p.data.filter((row) => {
            const date = p.getDate(row)
            if (p.fromDate && this.compaire(date,p.fromDate,p.unit) === 'less') { return false }
            if (p.toDate && this.compaire(date,p.toDate,p.unit) === 'greater') { return false }
            return true
        })
    }
}